import { Feather } from '@expo/vector-icons';
import { RouteProp, useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import React from 'react';
import { Text, useWindowDimensions, View } from 'react-native';
import { RectButton, TouchableOpacity, ScrollView } from 'react-native-gesture-handler';
import { titleCase } from '../../helpers';
import { RootStackParamList } from '../../routes/AppStack';
import styles from './styles';

type ChaptersScreenRouteProp = RouteProp<RootStackParamList, 'Chapters'>;
type ChaptersScreenNavigationProp = StackNavigationProp<RootStackParamList, 'Chapters'>;

type Props = {
  route: ChaptersScreenRouteProp;
  navigation: ChaptersScreenNavigationProp;
};

const Chapters = ({ route, navigation }: Props) => {

  const { goBack, navigate } = useNavigation();

  const { part, partIndex } = route.params;
  const width = useWindowDimensions().width < 500 ? '100%' : 500;


  return (
    <View 
      style={[
        styles.mainContainer,
        {
          width
        }
      ]}
    >
      <View style={styles.header}>
        <TouchableOpacity
          onPress={() => goBack()} 
        >
          <Feather name="arrow-left" size={28} />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Catecismo da Igreja Católica</Text>
      </View>

      <ScrollView contentContainerStyle={styles.chapters}>
        {
          part.sections && part.sections.map((section, index) => {
            const title = titleCase(section.title).replace(' (§', '\n(§');

            return (
              <RectButton 
                style={styles.chapter}
                onPress={() => navigate('Reading', {
                  partIndex,
                  sectionIndex: index,
                  comeFromHome: false
                })}
                key={index}
              >
                <View style={styles.chapterIconView}>
                  <Feather 
                    name="book" 
                    size={26}
                    color="#fff"
                  />
                </View>
                <Text style={styles.chapterTitle}>{title}</Text>
              </RectButton>
            );
          })
        }
      </ScrollView>
    </View>
  );
};

export default Chapters;